<app-shared-splash [title]="title"
    [subtitle]="subtitle"
    [bgUrl]="bgUrl"></app-shared-splash>
<app-cities-menu></app-cities-menu>